import { Button } from '@mui/material';
import * as React from 'react';

interface Props {
  onClose: () => void;
  title?: string;
  message?: string;
}

export const Error: React.FC<Props> = (props) => {
  const { onClose, message, title } = props;

  // This is to fix the subtle bug where closing the modal causes the text to disappear
  const [state, setState] = React.useState({ message, title });
  React.useEffect(() => {
    setState((s) => ({ title: title || s.title, message: message || s.message }));
  }, [message, title]);

  return (
    <div className="flex flex-col items-center">
      <div className="text-center space-y-4 pt-16 pb-32">
        <span className="text-6xl font-bold">⚠️</span>
        <h1 className="font-medium">{state.title}</h1>
        <p>{state.message}</p>
      </div>
      <div className="self-end">
        <Button onClick={onClose} variant="outlined" color="info" size="large" className="px-8">
          Close
        </Button>
      </div>
    </div>
  );
};
Error.displayName = 'SmartPerDiem.DownloadModal.Error';
